import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useAppSelector } from 'store';

import { $apiV2 } from 'modules/global';

import { ILessonTest, lessonConst } from '..';

export const getLessonTest = (slug?: string) => async () => {
  const { data } = await $apiV2.get(`/teacher-course/lessons/${slug}/test`);

  return { test: data?.data };
};

export const useLessonTest = (slug?: string) => {
  const queryClient = useQueryClient();
  const status = useAppSelector(({ lesson }) => lesson.status);

  const { data, ...args } = useQuery<{ test: ILessonTest }>({
    queryKey: [lessonConst.queryKeys.LESSONS_TEST, slug],
    queryFn: getLessonTest(slug),
    enabled: status === lessonConst.LessonStatus.SEEN
  });

  const refetchLessonTest = () =>
    queryClient.invalidateQueries({ queryKey: [lessonConst.queryKeys.LESSONS_TEST, slug] });

  return { ...data, ...args, refetchLessonTest };
};
